import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {setLocale, fetchSummaryInfo} from '../actions/';
import HomePage from '../components/Home/HomePage';

class HomeContainer extends Component {

  componentDidMount() {
    const { actions } = this.props;
    actions.fetchSummaryInfo();
  }
  
  componentWillReceiveProps(nextProps) { 
       
  }

  render() {
    const { actions } = this.props;
    const {summaryInfo} = this.props;
    return <HomePage actions={actions} summaryInfo={summaryInfo}/>;
  }
  
}

HomeContainer.propTypes = {
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {summaryInfo : state.summaryInfo};
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {setLocale, fetchSummaryInfo};
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);



// WEBPACK FOOTER //
// ./containers/HomeContainer.js